module.exports = __webpack_public_path__ + "videos/analytics.e01aaaa.mp4";